import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/Home.vue'
import * as path from "path";

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const HomeList=[

]
const urls = [

]
const UserList=[
  {
    path: '/user/product_info',
    component:()=>import('@/views/User/ProductInfo/UserProductInfo'),
    children: [
      {
        path: '/user/product_info/base',
        component:()=>import('../views/User/ProductInfo/ProductInfoBase')
      },
      {
        path: '/user/product_info/change:id',
        component:()=>import('../views/User/ProductInfo/ProductInfoChange')
      },
      {
        path: '/user/product_info/look:id',
        component:()=>import('../views/User/ProductInfo/ProductInfoLook')
      },
      {
        path: '/user/product_info/add',
        component:()=>import('../views/User/ProductInfo/ProductInfoAdd')
      },
      {
        path: '/user/product_info',
        redirect: '/user/product_info/base',
      }
    ]
  },
  {
    path: '/user/tag',
    component :()=>import('@/views/User/Tag/UseTag'),
    children: [
      {
        path:'/user/tag/look:id',
        component:()=>import('@/views/User/Tag/TagLook')
      },
      {
        path:'/user/tag/add',
        component:()=>import('@/views/User/Tag/TagAdd')
      },
      {
        path:'/user/tag/change:id',
        component:()=>import('@/views/User/Tag/TagChange')
      },
      {
        path: '/user/tag/base',
        component:()=>import('@/views/User/Tag/TagBase')
      },
      {
        path: '/user/tag',
        redirect: '/user/tag/base',
      }
    ]
  },
  {
    path: '/user/classify',
    component :()=>import('@/views/User/ProductClassify/UserProductClassify'),
    children: [
      {
        path:'/user/classify/look:id',
        component:()=>import('../views/User/ProductClassify/ProductClassifyLook')
      },
      {
        path:'/user/classify/add',
        component:()=>import('../views/User/ProductClassify/ProductClassifyAdd')
      },
      {
        path:'/user/classify/change:id',
        component:()=>import('../views/User/ProductClassify/ProductClassifyChange')
      },
      {
        path: '/user/classify/base',
        component:()=>import('../views/User/ProductClassify/ProductClassifyBase')
      },
      {
        path: '/user/classify',
        redirect: '/user/classify/base',
      }
    ]
  },
  {
    path: '/user/sign',
    component :()=>import('@/views/User/ProductSign/UserProductSign'),
    children: [
      {
        path:'/user/sign/look:id',
        component:()=>import('../views/User/ProductSign/ProductSignLook')
      },
      {
        path:'/user/sign/add',
        component:()=>import('../views/User/ProductSign/ProductSignAdd')
      },
      {
        path:'/user/sign/change:id',
        component:()=>import('../views/User/ProductSign/ProductSignChange')
      },
      {
        path:'/user/sign/base',
        component:()=>import('../views/User/ProductSign/ProductSignBase')
      },
      {
        path: '/user/sign',
        redirect: '/user/sign/base',
      }
    ]
  },
  {
    path: '/user/develop',
    component :()=>import('@/views/User/Develop/UserDevelop'),
    children: [
      {
        path:'/user/develop/look:id',
        component:()=>import('../views/User/Develop/DevelopLook')
      },
      {
        path:'/user/develop/add',
        component:()=>import('../views/User/Develop/DevelopAdd')
      },
      {
        path:'/user/develop/change:id',
        component:()=>import('../views/User/Develop/DevelopChange')
      },
      {
        path: '/user/develop/base',
        component:()=>import('../views/User/Develop/DevelopBase')
      },
      {
        path: '/user/develop',
        redirect: '/user/develop/base',
      }
    ]
  },
  {
    path: '/user/service',
    component :()=>import('@/views/User/Service/UserService'),
    children: [
      {
        path:'/user/service/look:id',
        component:()=>import('../views/User/Service/ServiceLook')
      },
      {
        path:'/user/service/add',
        component:()=>import('../views/User/Service/ServiceAdd')
      },
      {
        path:'/user/service/change:id',
        component:()=>import('../views/User/Service/ServiceChange')
      },
      {
        path:'/user/service/base',
        component:()=>import('../views/User/Service/base')
      },
      {
        path: '/user/service',
        redirect: '/user/service/base',
      }
    ]
  },
  {
    path: '/user/recruitment',
    component :()=>import('@/views/User/Recruitment/UserRecruitment'),
    children: [
      {
        path:'/user/recruitment/look:id',
        component:()=>import('../views/User/Recruitment/RecruitmentLook')
      },
      {
        path:'/user/recruitment/add',
        component:()=>import('../views/User/Recruitment/RecruitmentAdd')
      },
      {
        path:'/user/recruitment/change:id',
        component:()=>import('../views/User/Recruitment/RecruitmentChange')
      },
      {
        path:'/user/recruitment/base',
        component:()=>import('../views/User/Recruitment/RecruitmentBase')
      },
      {
        path: '/user/recruitment',
        redirect: '/user/recruitment/base',
      }
    ]
  },
  {
    path: '/user/company',
    component :()=>import('@/views/User/Company/UserCompany'),
    children: [
      {
        path:'/user/company/change',
        component:()=>import('../views/User/Company/CompanyChange')
      },
      {
        path: '/user/company/base',
        component:()=>import('../views/User/Company/CompanyBase')
      },
      {
        path: '/user/company',
        redirect: '/user/company/base',
      }
    ]
  },
  {
    path: '/user/supply',
    component :()=>import('@/views/User/Supply/UserSupply'),
    children: [
      {
        path: '/user/supply/base',
        component:()=>import('../views/User/Supply/SupplyBase')
      },
      {
        path:'/user/supply/look:id',
        component:()=>import('../views/User/Supply/SupplyLook')
      },
      {
        path:'/user/supply/add',
        component:()=>import('../views/User/Supply/SupplyAdd')
      },
      {
        path:'/user/supply/change:id',
        component:()=>import('../views/User/Supply/SupplyChange')
      },
      {
        path: '/user/supply',
        redirect: '/user/supply/base',
      }
    ]
  },
  {
    path: '/user/partner',
    component :()=>import('../views/User/Partner/UserPartner'),
    children: [
      {
        path:'/user/partner/look:id',
        component:()=>import('../views/User/Partner/PartnerLook')
      },
      {
        path:'/user/partner/add',
        component:()=>import('../views/User/Partner/PartnerAdd')
      },
      {
        path:'/user/partner/change:id',
        component:()=>import('../views/User/Partner/PartnerChange')
      },
      {
        path: '/user/partner/base',
        component:()=>import('../views/User/Partner/PartnerBase')
      },
      {
        path: '/user/partner',
        redirect: '/user/partner/base',
      }
    ]
  },
  {
    path: '/user/manage',
    component :()=>import('../views/User/Manage/UserManage'),
    children: [
      {
        path:'/user/manage/look:id',
        component:()=>import('../views/User/Manage/ManageLook')
      },
      {
        path:'/user/manage/add',
        component:()=>import('../views/User/Manage/ManageAdd')
      },
      {
        path:'/user/manage/change:id',
        component:()=>import('../views/User/Manage/ManageChange')
      },
      {
        path:'/user/manage/base',
        component:()=>import('../views/User/Manage/base')
      },
      {
        path: '/user/manage',
        redirect: '/user/manage/base',
      }
    ]
  },
  {
    path: '/user/pic_info',
    component :()=>import('../views/User/PicInfo/UserPicInfo'),
    children: [
      {
        path:'/user/pic_info/look:id',
        component:()=>import('../views/User/PicInfo/PicInfoLook')
      },
      {
        path:'/user/pic_info/add',
        component:()=>import('../views/User/PicInfo/PicInfoAdd')
      },
      {
        path:'/user/pic_info/change:id',
        component:()=>import('../views/User/PicInfo/PicInfoChange')
      },
      {
        path: '/user/pic_info/base',
        component:()=>import('../views/User/PicInfo/PicInfoBase')
      },
      {
        path: '/user/pic_info',
        redirect: '/user/pic_info/base',
      }
    ]
  },
  {
    path: '/user/pic',
    component :()=>import('../views/User/UserPic'),
  },
  {
    path: '/user/menu',
    component :()=>import('../views/User/UserMenu'),
  },
  {
    path: '/user/quality',
    component:()=>import('../views/User/Quality/UserQuality'),
    children: [
      {
        path: '/user/quality/base',
        component:()=>import('../views/User/Quality/QualityBase')
      },
      {
        path: '/user/quality/change:id',
        component:()=>import('../views/User/Quality/QualityChange')
      },
      {
        path: '/user/quality/look:id',
        component:()=>import('../views/User/Quality/QualityLook')
      },
      {
        path: '/user/quality/add',
        component:()=>import('../views/User/Quality/QualityAdd')
      },
      {
        path: '/user/quality',
        redirect: '/user/quality/base',
      }
    ]
  },
  {
    path: '/user/news',
    component:()=>import('../views/User/News/UserNews'),
    children: [
      {
        path: '/user/news/base',
        component:()=>import('../views/User/News/NewsBase')
      },
      {
        path: '/user/news/change:id',
        component:()=>import('../views/User/News/NewsChange')
      },
      {
        path: '/user/news/look:id',
        component:()=>import('../views/User/News/NewsLook')
      },
      {
        path: '/user/news/add',
        component:()=>import('../views/User/News/NewsAdd')
      },
      {
        path: '/user/news',
        redirect: '/user/news/base',
      }
    ]
  },
  {
    path: '/user/service_concept',
    component:()=>import('../views/User/ServiceConcept/UserConcept'),
    children: [
      {
        path: '/user/service_concept/base',
        component:()=>import('../views/User/ServiceConcept/ConceptBase')
      },
      {
        path: '/user/service_concept/change:id',
        component:()=>import('../views/User/ServiceConcept/ConceptChange')
      },
      {
        path: '/user/service_concept/look:id',
        component:()=>import('../views/User/ServiceConcept/ConceptLook')
      },
      {
        path: '/user/service_concept/add',
        component:()=>import('../views/User/ServiceConcept/ConceptAdd')
      },
      {
        path: '/user/service_concept',
        redirect: '/user/service_concept/base',
      }
    ]
  },
  {
    path: '/user/land',
    component:()=>import('../views/User/Land/UserLand'),
    children: [
      {
        path: '/user/land/base',
        component:()=>import('../views/User/Land/LandBase')
      },
      {
        path: '/user/land/change:id',
        component:()=>import('../views/User/Land/LandChange')
      },
      {
        path: '/user/land/look:id',
        component:()=>import('../views/User/Land/LandLook')
      },
      {
        path: '/user/land/add',
        component:()=>import('../views/User/Land/LandAdd')
      },
      {
        path: '/user/land',
        redirect: '/user/land/base',
      }
    ]
  },
  {
    path: '/user',
    redirect: '/user/menu'
  }
]

const routes = [
  {
    path:'/',
    component: ()=> import('@/views/Base/Base'),
    children: [
      {
        path: '/',
        redirect:'/home',
      },
      {
        path: '/home',
        component: ()=>import('@/views/Home/Home'),
      },
      {
        path: '/qualification',
        component: ()=>import('../views/Home/HomeQualification/QualityEnter')
      },
      {
        path: '/case',
        component:()=>import('../views/Home/HomeCase/CaseEnter'),
        children:[
          {
            path:'/case/enter',
            component:()=>import('../views/Home/HomeCase/CaseBase'),
          },
          {
            path: '/case',
            redirect:'/case/enter'
          },
          {
            path:'/case/detail/:id',
            component:()=>import('../views/Home/HomeCase/CaseDetail'),
          },

        ]
      },
      {
        path: '/news',
        component:()=>import('../views/Home/HomeNews/NewsEnter'),
        children: [
          {
            path: '/news/enter',
            component:()=>import('../views/Home/HomeNews/NewsBase')
          },
          {
            path: '/news',
            redirect: '/news/enter',
          },
          {
            path: '/news/detail/:id',
            component:()=>import('../views/Home/HomeNews/NewsDetail')
          }
        ]
      },
      {
        path: '/choose',
        component:()=>import('../views/Home/HomeChoose/ChooseBase')
      },
      {
        path: '/society',
        component:()=>import('../views/Home/HomeRipeav/HomeSociety')
      },
      {
        path: '/eden',
        component:()=>import('../views/Home/HomeRipeav/HomeEdgn')
      },
      {
        path: '/about',
        component: ()=>import('views/About/About'),
        children: [
          {
            path: '/about/intro',
            component:()=>import('../views/About/CompanyInfo')
          },
          {
            path: '/about/hope',
            component:()=>import('../views/About/CompanyHope')
          },
          {
            path: '/about/mean',
            component:()=>import('../views/About/CompanyMean')
          },
          {
            path: '/about/develop',
            component:()=>import('../views/About/Company')
          },
          {
            path: '/about/culture',
            component:()=>import('../views/About/CompanyCulture')
          },
          {
            path: '/about',
            redirect: '/about/intro'
          }
        ]
      },
      {
        path:'/service',
        component: ()=>import('views/Service/Service'),
        children: [
          {
            path: '/service/service_concept',
            component:()=>import('../views/Service/ServiceItem/ServiceConcept')
          },
          {
            path: '/service/service_tel',
            component:()=>import('../views/Service/ServiceItem/ServiceTel')
          },
          {
            path: '/service/service_train',
            component:()=>import('../views/Service/ServiceItem/ServiceTrain')
          },
          {
            path: '/service/service_drive',
            component:()=>import('../views/Service/ServiceItem/ServiceDrive')
          },
          {
            path: '/service/service_operation',
            component:()=>import('../views/Service/ServiceItem/ServiceConcept')
          },
          {
            path: '/service',
            redirect: '/service/service_tel'
          }
        ]
      },
      {
        path: '/partner',
        component: ()=>import('views/Partner/Partner')
      },
      {
        path: '/join',
        component: ()=>import('views/Join/Join'),
        children: [
          {
            path: '/join/detail',
            component: ()=>import('views/Join/JoinDetail')
          },
          {
            path:'/join',
            redirect: '/join/enter'
          },
          {
            path: '/join/enter',
            component: ()=>import('views/Join/JoinEnter')
          }
        ]
      },
      {
        path: '/product',
        component: ()=>import('views/Product/Product'),
        children:[
          {
            path:'/product',
            component:()=>import('views/Product/home/base'),
          },
          {
            path:'/product/list/:id',
            component:()=>import('views/Product/list/list.vue')
          },
          {
            path:'/product/detail/:id',
            component:()=>import('views/Product/GoodsDetail/GoodsDetail.vue')
          },
        ]
      },
      {
        path: '/content/name=:name',
        component: ()=>import('../views/Home/content/index')
      },
    ]
  },
  {
    path: '/login',
    component: ()=>import('views/Login/Login')
  },
  {
    path: '/user',
    component: ()=>import('views/User/User'),
    children: UserList
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
